import { PageId } from 'constants/pages'

export const enum PageIdIntlMw {
  ANALYZING = PageId.ANALYZING_INTL_MW,
  START = PageId.START_INTL_MW,
  LIVING_UP_POTENTIAL = PageId.LIVING_UP_POTENTIAL_INTL_MW,
  STRUGGLE_MOST = PageId.STRUGGLE_MOST_INTL_MW,
  STUCK_AREAS = PageId.STUCK_AREAS_INTL_MW,
  REASON_TO_START = PageId.REASON_TO_START_INTL_MW,
  GOOD_COMPANY = PageId.GOOD_COMPANY_INTL_MW,
  LITTLE_INTEREST = PageId.LITTLE_INTEREST_INTL_MW,
  EMOTION_SHIFTS = PageId.EMOTION_SHIFTS_INTL_MW,
  CALM_DOWN = PageId.CALM_DOWN_INTL_MW,
  RECHARGING = PageId.RECHARGING_INTL_MW,
  ACCEPT_COMPLIMENTS = PageId.ACCEPT_COMPLIMENTS_INTL_MW,
  PRIORITIZE_OTHERS = PageId.PRIORITIZE_OTHERS_INTL_MW,
  LEAN_ON_SOMEONE = PageId.LEAN_ON_SOMEONE_INTL_MW,
  UNDERSTOOD_BY_OTHERS = PageId.UNDERSTOOD_BY_OTHERS_INTL_MW,
  WE_FEEL_YOU = PageId.WE_FEEL_YOU_INTL_MW,
  OVERTHINKING_DECISIONS = PageId.OVERTHINKING_DECISIONS_INTL_MW,
  AUTOPILOT = PageId.AUTOPILOT_INTL_MW,
  UNABLE_TO_START = PageId.UNABLE_TO_START_INTL_MW,
  DISTRACTIONS = PageId.DISTRACTIONS_INTL_MW,
  MEANING_TO_DO = PageId.MEANING_TO_DO_INTL_MW,
  OTHER_SIDE = PageId.OTHER_SIDE_INTL_MW,
  GENUINE_STRENGTHS = PageId.GENUINE_STRENGTHS_INTL_MW,
  TIME_INVESTMENT = PageId.TIME_INVESTMENT_INTL_MW,
  HEAR_ABOUT_US = PageId.HEAR_ABOUT_US_INTL_MW,
  PREPARE_FLOW = PageId.PREPARE_FLOW_INTL_MW,
  PATTERNS_IMPACT = PageId.PATTERNS_IMPACT_INTL_MW,
  EMAIL = PageId.EMAIL_INTL_MW,
  OFFER = PageId.OFFER_INTL_MW,
  SPECIAL_DISCOUNT = PageId.SPECIAL_DISCOUNT_INTL_MW,
  CANCEL_OFFER = PageId.CANCEL_OFFER_INTL_MW,
  PAYMENT = PageId.PAYMENT_INTL_MW,
  REGISTRATION = PageId.REGISTRATION_INTL_MW,
  NAME_ENTRY = PageId.NAME_ENTRY_INTL_MW,
  REPORT = PageId.REPORT_INTL_MW,
}
